import throttle from 'lodash/throttle.js';
import { FLOATING_ADD_TO_CART_DELAY, MAIN_ADD_TO_CART_ID } from '~~/constants/floatingAddToCart';

export const useFloatingATCSection = () => {

  const showFloatingAddToCart = ref<boolean>(false);
  const mainAddToCart = ref<Nullable<HTMLElement>>(null);

  const getATCElement = () => {

    if (mainAddToCart.value?.isConnected) {

      return mainAddToCart.value;

    }
    mainAddToCart.value = document.getElementById(MAIN_ADD_TO_CART_ID);

    return mainAddToCart.value;
  
  };

  const areWeBelowMainATC = (): boolean => {

    const mainATCEl = getATCElement();

    if (!mainATCEl?.isConnected) {

      return false;

    }
    const buttonRect = mainATCEl.getBoundingClientRect();

    return buttonRect.bottom <= 0;
  
  };

  const checkSectionVisibility = throttle(() => {

    showFloatingAddToCart.value = areWeBelowMainATC();
  
  }, FLOATING_ADD_TO_CART_DELAY);

  const addScrollEvent = () => {

    window.addEventListener('scroll', checkSectionVisibility, { passive: true }); 

  };
  const removeScrollEvent = () => {

    window.removeEventListener('scroll', checkSectionVisibility); 

  };

  onMounted(() => {

    addScrollEvent();
    checkSectionVisibility();
  
  });

  onUnmounted(() => {

    removeScrollEvent();
  
  });

  return { showFloatingAddToCart };

};
